<div class="custom-confirm-dialog">
  <p-toast [key]="MESSAGE_KEYS.global" />
  <p-confirmDialog key="cdLogout" [autoZIndex]="true" />
</div>
<router-outlet></router-outlet>
